import React, { useState, useEffect } from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

const ScrollButtons = () => {
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show buttons when user has scrolled down 100px
      setShowButtons(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className={`fixed right-8 bottom-8 flex flex-col gap-4 transition-opacity duration-300 ${showButtons ? 'opacity-100' : 'opacity-0'}`}>
      <button
        onClick={scrollToTop}
        className="p-3 bg-[#0C60F2] text-white rounded-full shadow-lg hover:bg-blue-700 transition-colors focus:outline-none"
        aria-label="Scroll to top"
      >
        <ArrowUp size={24} />
      </button>
      <button
        onClick={scrollToBottom}
        className="p-3 bg-[#0C60F2] text-white rounded-full shadow-lg hover:bg-blue-700 transition-colors focus:outline-none"
        aria-label="Scroll to bottom"
      >
        <ArrowDown size={24} />
      </button>
    </div>
  );
};

export default ScrollButtons;